import { Button } from "components"
import { TabRegisterPath } from "../../types"
import { PERMISION } from "security"

type TabRegisterProps = {
  activeTab: string
  setActiveTab: (path: string) => void
}

type Tabs = {
  label: string
  path: TabRegisterPath
  permission: string
}

export function TabNavRegister({ activeTab, setActiveTab }: TabRegisterProps) { 

  const tabs: Tabs[] = [
    { label: "By Date Range", path: "by-date-range", permission: PERMISION.FINANCE.REGISTER.BY_DATE_RANGE.PERMISION },
    { label: "By Card", path: "by-card", permission: PERMISION.FINANCE.REGISTER.BY_CARD.PERMISION },
    { label: "By Location", path: "by-location", permission: PERMISION.FINANCE.REGISTER.BY_LOCATION.PERMISION },
    { label: "Reference Id", path: "reference-id", permission: PERMISION.FINANCE.REGISTER.REFERENCE_ID.PERMISION },
    { label: "Reconcilliation", path: "reconcilliation", permission: PERMISION.FINANCE.REGISTER.RECONCILLIATION.PERMISION },
  ]

  return (
    <section className="grow flex items-stretch overflow-x-auto">
      {tabs.map((tab) => (
        <Button
          key={tab?.path}
          permission={tab?.permission}
          type="button"
          color="ghost"
          size="sm"
          className={`grow bg-[#3c3c3c] border-y-0 border-x border-white no-animation hover:bg-primary hover:text-black whitespace-nowrap uppercase ${tab.path === activeTab ? "bg-primary text-black" : "text-white"}`}
          onClick={() => setActiveTab(tab?.path)}
        >
          {tab.label}
        </Button>
      ))}
    </section>
  )
}
